import { Stack, Text, Title } from '@mantine/core';
import { UvMethodSetting } from '@/app/workflows/components/v6/operations/settings/form/sections/uvUnwrapping/settings/UvMethodSetting';
import { UvScaleSetting } from '@/app/workflows/components/v6/operations/settings/form/sections/uvUnwrapping/settings/UvScaleSetting';

export function UvUnwrappingOperation() {
  return (
    <Stack align='start'>
      <Title order={5}>UV Unwrapping</Title>
      <Text c='gray.6'>Unwrap UVs of an input model.</Text>
      <Stack gap='xl'>
        <UvMethodSetting />
        <UvScaleSetting />
      </Stack>
    </Stack>
  );
}
